import { openDB } from 'idb';

const DB_NAME = 'lewotobi-offline';
const DB_VERSION = 1;
const LOGS_STORE = 'logs';

const dbPromise = openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
        if (!db.objectStoreNames.contains(LOGS_STORE)) {
            db.createObjectStore(LOGS_STORE, { keyPath: 'id' });
        }
    },
});

export const offlineStorage = {
    async saveLog(logData) {
        const db = await dbPromise;
        // Clone data to avoid proxy issues, especially with Vue observables
        const data = JSON.parse(JSON.stringify(logData));

        // If there are image files (Blobs/Files) in the post, we need to handle them specially
        // because JSON.stringify strips them. 
        // However, the passing component should probably pass raw objects before stringifying?
        // Let's assume logData comes in with 'posts' array where images might be File objects.
        // Structured Clone Algorithm supports Blobs/Files in IDB.

        // We'll perform a shallow copy and keep the Files intact if possible, 
        // or we expect the caller to pass a structure that IDB can handle.
        // IDB can store File objects directly.

        return db.put(LOGS_STORE, logData);
    },

    async getPendingLogs() {
        const db = await dbPromise;
        return db.getAll(LOGS_STORE);
    },

    async deleteLog(id) {
        const db = await dbPromise;
        return db.delete(LOGS_STORE, id);
    },

    async clearAll() {
        const db = await dbPromise;
        return db.clear(LOGS_STORE);
    }
};
